import { createVueInstance } from '../utils'
import Modal from './_modal'
export default createVueInstance(Modal)



// WEBPACK FOOTER //
// ./src/components/modal.js